// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__1wQ3F","item":"Menu_item__3reEH","underline":"Menu_underline__2B5_G","active":"Menu_active__3ax4o","link":"Menu_link__1hJ0p"};